import React from 'react';
import {
 Button
} from 'shared/components/ui/button';
import {
 useNavigate
} from 'react-router-dom';
import {
 Plus, Cable
} from 'lucide-react';

const DashboardQuickActions: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-wrap gap-3">
            <Button onClick={() => navigate('connections')} variant="outline">
                <Plus className="mr-2 h-4 w-4" />
                <Cable className="mr-2 h-4 w-4" />
                New Connection
            </Button>
        </div>
    );
};

export default DashboardQuickActions;
